import { useRef, useEffect, useState } from 'react';
import { getActiveState } from '../helpers/titreHelper';
import { useGetParams } from './useGetParams';
import { useInterval } from './useInterval';

export const useMultiBroadcast = () => {
  const { user } = useGetParams();
  const [currentState, setCurrentState] = useState(null);
  const [isVisible, setIsVisible] = useState(null);
  const [showedMessages, setShowedMessages] = useState([]);

  const lastMessageIdRef = useRef(0);
  const messagesRef = useRef([]);

  const iactiveIdRef = useRef('');

  const protocol = window?.location.protocol || 'https:';

  const getMultiBroadcastInfo = async () => {
    try {
      const response = await fetch(
        `${protocol}//api.stream.iactive.pro/titreInfo?user=${user}&from=${lastMessageIdRef.current}&type=1`,
        { cache: 'no-store' },
      );
      const data = await response.json();
      if (!data) return;
      let { messagesList, deletedMessagesIdList, visibility, iactiveId } = data;

      if (!visibility && visibility !== isVisible) {
        setIsVisible(false);
        return;
      } else if (visibility && visibility !== isVisible) {
        setIsVisible(true);
      }

      // При запуске следующей трансляции обновление

      if (iactiveIdRef.current !== iactiveId) {
        messagesRef.current = [];
      }

      if (
        data?.statusList[0]?.state &&
        getActiveState(data?.statusList[0]?.state) !== currentState
      ) {
        setCurrentState(getActiveState(data?.statusList[0].state));
      }

      // Удаляем сообщения по команде пользователя

      // если имеются в списке сообщений удаленные
      if (
        messagesRef.current.some((el) => deletedMessagesIdList.includes(+el.id))
      ) {
        messagesRef.current = messagesRef.current.filter(
          (el) => !deletedMessagesIdList.includes(+el.id),
        );
      }

      // Удаляем сообщения, если они не содержат текста или картинки.
      messagesList = messagesList.filter((el) => el.message.content !== '');

      //запоминаем id последнего сообщения, для дальнейших запросов
      if (iactiveIdRef.current && iactiveIdRef.current !== iactiveId) {
        lastMessageIdRef.current = 0;
        iactiveIdRef.current = iactiveId;
        return;
      } else {
        iactiveIdRef.current = iactiveId;
        lastMessageIdRef.current =
          messagesList[0]?.id || lastMessageIdRef.current;
      }

      if (
        messagesList.length > 0 ||
        messagesRef.current.length !== showedMessages.length
      ) {
        messagesRef.current = [
          ...messagesRef.current,
          ...messagesList.reverse(),
        ];
        setShowedMessages(messagesRef.current);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getMultiBroadcastInfo();
  }, []);

  // Получение информации о титре
  useInterval(getMultiBroadcastInfo, 2000);

  return {
    currentState,
    isVisible,
    showedMessages,
  };
};
